import { useEffect } from 'react';

import type { ACTION_SUBJECT_ID } from '@atlaskit/editor-common/analytics';
import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';
import type { EditorState } from '@atlaskit/editor-prosemirror/state';

import type { AIPlugin } from '../../../aiPluginType';
import {
	fireButtonViewedAnalyticsEvent,
	selectionCharWordCount,
} from '../../utils/analytics/utils';

export const useToolbarButtonViewedAnalytics = ({
	api,
	state,
	enabled,
	actionSubjectId,
}: {
	actionSubjectId:
		| ACTION_SUBJECT_ID.AI_HERO_PROMPT_BUTTON
		| ACTION_SUBJECT_ID.AI_ASK_ROVO_BUTTON
		| ACTION_SUBJECT_ID.AI_DEFINITIONS_DEFINE_BUTTON;
	api?: ExtractInjectionAPI<AIPlugin>;
	enabled?: boolean;
	state?: EditorState;
}) => {
	useEffect(() => {
		if (!enabled || !state) {
			return;
		}

		const { charCount, wordCount } = selectionCharWordCount(state);

		fireButtonViewedAnalyticsEvent({
			api,
			actionSubjectId,
			attributes: {
				selectionCharCount: charCount,
				selectionWordCount: wordCount,
			},
		});
	}, [actionSubjectId, api, enabled, state]);
};
